export const countOccurrences = (mainString: string, subString: string): number => {
    return mainString.split('').reduce((count, ch) => ch === subString ? count + 1 : count, 0);
}
